import { createFields } from "../helpers/createFields.js";
const consentsFields = createFields({
  marketingCommunicationConsentAccepted: {
    __type: "checkbox",
    label: "field.marketing_consent",
    name: "marketingCommunicationConsentAccepted"
  },
  dentalSupplementaryInsuranceAccepted: {
    __type: "checkbox",
    label: "field.supplementary_dental_insurance_offer_accepted",
    name: "dentalSupplementaryInsuranceAccepted"
  },
  insuranceConsentAccepted: {
    __type: "checkbox",
    label: "field.insurance_consent",
    name: "insuranceConsentAccepted"
  },
  confidentialityAgreementAccepted: {
    __type: "checkbox",
    label: "field.confidentiality_declaration",
    name: "confidentialityAgreementAccepted",
    inputProps: {
      withText: true
    },
    isRequired: true
  }
});
export {
  consentsFields as default
};
